module.exports = __webpack_public_path__ + "static/media/sarvvid.790fff08.png";